import { QueryKeys } from '@shared/domain/queryKeys'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

const FRANKFURTER_BASE = '/api/frankfurter'

const fetchCurrencies = async (): Promise<Record<string, string>> => {
  const { data } = await axios.get<Record<string, string>>(
    `${FRANKFURTER_BASE}/currencies`
  )
  return data
}

export const useGetCurrencies = () => {
  return useQuery({
    queryKey: [QueryKeys.Currencies],
    queryFn: fetchCurrencies,
    staleTime: Infinity,
  })
}
